/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierUserSetPasswordRequest
 */
export interface CourierUserSetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierUserSetPasswordRequest
     */
    newPassword: string;
}

/**
 * Check if a given object implements the CourierUserSetPasswordRequest interface.
 */
export function instanceOfCourierUserSetPasswordRequest(value: object): value is CourierUserSetPasswordRequest {
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function CourierUserSetPasswordRequestFromJSON(json: any): CourierUserSetPasswordRequest {
    return CourierUserSetPasswordRequestFromJSONTyped(json, false);
}

export function CourierUserSetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierUserSetPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newPassword': json['newPassword'],
    };
}

export function CourierUserSetPasswordRequestToJSON(json: any): CourierUserSetPasswordRequest {
    return CourierUserSetPasswordRequestToJSONTyped(json, false);
}

export function CourierUserSetPasswordRequestToJSONTyped(value?: CourierUserSetPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newPassword': value['newPassword'],
    };
}

